import { jsx as _jsx } from "react/jsx-runtime";
import { CaretUp } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
const rotations = {
    none: 'rotate-90',
    asc: '',
    desc: 'rotate-180',
};
const SortIcon = ({ sortDirection }) => (_jsx(CaretUp, { size: 8, color: "#000", weight: "fill", className: twMerge('transition-all duration-300', rotations[sortDirection]) }));
export const SortIndicator = ({ isSorted, hoveredId, id }) => (_jsx("div", { className: "inline-block w-2", children: isSorted ? (_jsx(SortIcon, { sortDirection: isSorted })) : hoveredId === id ? (_jsx(SortIcon, { sortDirection: "none" })) : null }));
//# sourceMappingURL=SortIndicator.js.map